//加密JS
import CryptoJS from 'crypto-js'




/**
 * 工具类
 * AES加密
 * 特别注意：（1）AES加密中需要前后端共同协商一个密文(密钥),用来加密/解密的（2）偏移量。
 * abcdefG123456789 代表此次密文
 */
// CBC模式
// 特别注意：此次是将密文写死到函数内部，也可以当成函数的参数进行动态绑定密文,列如：
// export const fstEncrypt = function(str, key_hash, _iv) {
//   if (!str) {
//     return str;
//   }
//   let keyStr = key_hash; // 密钥
//   let ivStr = _iv; // 偏移量
//   let key = CryptoJS.enc.Utf8.parse(keyStr);
//   let iv = CryptoJS.enc.Utf8.parse(ivStr);
//   let srcs = CryptoJS.enc.Utf8.parse(str);
//   let encrypted = CryptoJS.AES.encrypt(srcs, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   // console.log(global, 'CBC模式')
//   return encrypted.toString();
// }
// // 解密
// export const fstDecrypt = function(word, key_hash, _iv) {
//   let keyStr = key_hash; // 密钥
//   let ivStr = _iv; // 偏移量
//   let base64 = CryptoJS.enc.Utf8.parse(word)
//   var key = CryptoJS.enc.Utf8.parse(keyStr);
//   let iv = CryptoJS.enc.Utf8.parse(ivStr);
//   let src = CryptoJS.enc.Utf8.stringify(base64)
//   var decrypt = CryptoJS.AES.decrypt(src, key, {
//     iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   let decryptedObj = JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt))
//   return decryptedObj
// }










/**
 * 接口数据加密函数
 * @param str string 需加密的json字符串
 * @param key_hash string 加密key_hash(16位)
 * @param iv string 加密向量(16位)
 * @return string 加密密文字符串
 */
export const fstEncrypt = (str, key_hash, _iv) => {
  if (!str) {
    return str;
  }
  //密钥
  var key = CryptoJS.enc.Utf8.parse(key_hash);
  //加密向量
  var iv = CryptoJS.enc.Utf8.parse(_iv);
  var encrypted = CryptoJS.AES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
//   console.log(encrypted.toString(), str, ">>str");
  return encrypted.toString();


};

/**
 * 接口数据解密函数
 * @param str string 已加密密文
 * @param key_hash string 加密key_hash
 * @param iv string 加密向量
 * @returns {*|string} 解密之后的json字符串
 */
export const fstDecrypt = (str, key_hash, _iv) => {
  if (!str) {
    return str;
  }
  //密钥
  var key = CryptoJS.enc.Utf8.parse(key_hash);
  //加密向量
  var iv = CryptoJS.enc.Utf8.parse(_iv);
  let base64 = CryptoJS.enc.Utf8.parse(str);
  let src = CryptoJS.enc.Utf8.stringify(base64);
  var decrypted = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

 let decryptedObj = JSON.parse(CryptoJS.enc.Utf8.stringify(decrypted));
//  console.log(decryptedObj,"=============")
 return decryptedObj;
};
